import { render } from "./Selecionados.vue?vue&type=template&id=41ffe896&scoped=true"
import script from "./Selecionados.vue?vue&type=script&lang=js"
export * from "./Selecionados.vue?vue&type=script&lang=js"

import "./Selecionados.vue?vue&type=style&index=0&id=41ffe896&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ffe896"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QTable,QTd,QSelect,QPagination,QBtn});
